// extracted by mini-css-extract-plugin
export default {"menu_wrapper":"menu_menu_wrapper__A10Vw"};